import React from 'react';
import PropTypes from 'prop-types';

const LinkIcon = ({ className, width, height, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 1000 1000"
  >
    <path
      className="icon linkIcon"
      fill={fill}
      d="M380.5,441.3c20.2-20.2,43.5-35.8,69.9-46.6c26.3-10.8,53.3-16.2,81-16.2c27.7,0,54.7,5.4,81,16.2	c26.3,10.8,49.6,26.3,69.9,46.6c20.2,20.2,35.8,43.5,46.6,69.9c10.8,26.3,16.2,53.3,16.2,81c0,27.7-5.4,54.7-16.2,81 c-10.8,26.3-26.3,49.6-46.6,69.9L498,927.2c-10.8,10.8-22,19.9-33.4,27.3c-11.5,7.4-23.6,13.8-36.4,19.2 c-12.8,5.4-26,9.4-39.5,12.1c-13.5,2.7-27.7,4.1-42.5,4.1c-13.5,0-27-1.4-40.5-4.1c-13.5-2.7-26.7-6.8-39.5-12.1 c-12.8-5.4-25-11.8-36.4-19.2c-11.5-7.4-22.6-16.5-33.4-27.3c-21.6-20.2-37.5-43.5-47.6-69.9s-15.2-53.3-15.2-81 c0-27.7,5.1-54.3,15.2-80c10.1-25.6,26-49.3,47.6-70.9l64.8-64.8l42.5,42.5l-64.8,64.8c-14.9,14.9-26,31.7-33.4,50.6 c-7.4,18.9-11.1,38.2-11.1,57.7c0,19.6,3.7,38.8,11.1,57.7c7.4,18.9,18.5,35.8,33.4,50.6c14.8,14.9,31.7,26,50.6,33.4	c18.9,7.4,38.1,11.1,57.7,11.1c19.6,0,38.8-3.7,57.7-11.1c18.9-7.4,35.8-18.5,50.6-33.4l184.3-184.3c14.8-14.8,26-31.7,33.4-50.6 c7.4-18.9,11.1-38.1,11.1-57.7c0-19.6-3.7-38.8-11.1-57.7c-7.4-18.9-18.6-35.8-33.4-50.6c-14.9-14.8-31.7-26-50.6-33.4	c-18.9-7.4-38.2-11.1-57.7-11.1c-19.6,0-38.8,3.7-57.7,11.1c-18.9,7.4-35.8,18.6-50.6,33.4l-8.1,8.1l-42.5-42.5L380.5,441.3z M803.7,374.5c20.2-20.2,35.8-43.5,46.6-69.9c10.8-26.3,16.2-53.3,16.2-81c0-27.7-5.4-54.7-16.2-81C839.5,116.3,824,93,803.7,72.8	c-20.2-20.2-43.5-35.8-69.9-46.6c-26.3-10.8-53.3-16.2-81-16.2c-27.7,0-54.7,5.4-81,16.2C545.6,37,522.3,52.5,502,72.8L319.8,255 c-20.2,20.2-35.8,43.5-46.6,69.9c-10.8,26.3-16.2,53.3-16.2,81c0,27.7,5.4,54.7,16.2,81c10.8,26.3,26.3,49.6,46.6,69.9	c10.8,10.8,21.9,19.9,33.4,27.3c11.5,7.4,23.6,13.9,36.4,19.2c12.8,5.4,26,9.5,39.5,12.2c13.5,2.7,27.7,4,42.5,4	c13.5,0,27-1.3,40.5-4c13.5-2.7,26.6-6.7,39.5-12.2c12.8-5.4,25-11.8,36.4-19.2c11.5-7.4,22.6-16.5,33.4-27.3L579,514.2	c-14.9,14.9-31.7,26-50.6,33.4c-18.9,7.4-38.2,11.1-57.7,11.1c-19.6,0-38.8-3.7-57.7-11.1c-18.9-7.4-35.8-18.5-50.6-33.4	c-14.9-14.8-26-31.7-33.4-50.6c-7.4-18.9-11.1-38.1-11.1-57.7c0-19.6,3.7-38.8,11.1-57.7c7.4-18.9,18.5-35.8,33.4-50.6l182.2-182.2 c14.8-14.8,31.7-26,50.6-33.4c18.9-7.4,38.1-11.1,57.7-11.1c19.6,0,38.8,3.7,57.7,11.1c18.9,7.4,35.8,18.6,50.6,33.4 c14.8,14.9,26,31.7,33.4,50.6c7.4,18.9,11.1,38.2,11.1,57.7c0,19.6-3.7,38.8-11.1,57.7c-7.4,18.9-18.6,35.8-33.4,50.6l-58.7,56.7 l44.5,42.5L803.7,374.5z"
    />
  </svg>
);

LinkIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};

LinkIcon.defaultProps = {
  height: '100%',
  fill: 'currentColor',
};

export default LinkIcon;
